export default __webpack_public_path__ + "23760d205c0c38e42ffbe353941fc952.svg";